<script lang="ts">
    import MainLayout from '../../../#common/layout/Layout.svelte'
    import {Link} from 'svelte-routing'
    import {api} from '../../../../../services/api/reallis'
    import backIcon from 'src/components/cabinet/#assets/left-icon.svg'
    import {showAlert} from '../../../../#common/alert/store'
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import IconifyIcon from '@iconify/svelte'
    import hideIcon from '@iconify/icons-fa-solid/eye'
    import showIcon from '@iconify/icons-fa-solid/eye-slash'
    import {userProfile} from "src/services/auth"

    let error
    let errorStatus = false
    let errorText = ''
    let newPassword = ''
    let repeatPassword = ''
    let oldPassword = ''
    let changePasswordSending = false
    let type = "text"

    async function changePassword() {
        if (oldPassword.length < 8 || newPassword.length < 8 || repeatPassword.length < 8) {
            errorStatus = true
            errorText = 'Must be at least 8 characters'
            return
        }

        if (newPassword !== repeatPassword) {
            errorStatus = true
            errorText = 'Password mismatch'
            return
        }

        if (oldPassword === newPassword) {
            errorStatus = true
            errorText = 'Old and new passwords must be different'
            return
        }

        try {
            changePasswordSending = true
            errorStatus = false

            await api.ws.ws1.request({
                data: {
                    agent: "auth",
                    auth: {type: "webSite"},
                    lang: "en",
                    method: "auth_changePassword",
                    params: {
                        "username": $userProfile.email,
                        "password": oldPassword,
                        "newPassword": newPassword
                    }
                }
            })

            newPassword = ''
            repeatPassword = ''
            oldPassword = ''

            showAlert.set({
                status: 'success',
                text: 'Password changed successfully'
            })
        } catch (err) {
            console.error(err)
            errorStatus = true;
            errorText = err.message;
        } finally {
            changePasswordSending = false
        }
    }

    let showOldPassword = false
    let showNewPassword = false
    let showRepeatPassword = false

    function showHideOldPassword() {
        showOldPassword = !showOldPassword
    }

    function showHideNewPassword() {
        showNewPassword = !showNewPassword
    }

    function showHideRepeatPassword() {
        showRepeatPassword = !showRepeatPassword
    }
</script>

<svelte:head>
    <title>Password change</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <Alert />
            <div class="page-title">
                <Link to="settings" class="btn btn-second back"><img src={backIcon} alt=""> Back</Link>
            </div>
            <div class="row">
                <div class="col-lg-10 col-xl-8 col-xxl-6 vertical-line pr-8">
                    <div class="page-subtitle">Change password</div>
                    <div class="form-group">
                        <div class="field-note">To change the password, you need to confirm the current password from your account.</div>
                        <div class="position-relative">
                            {#if showOldPassword === true}
                                <input type="text" bind:value={oldPassword} class="form-control field mb-3" placeholder="Your old password">
                            {:else}
                                <input type="password" bind:value={oldPassword} class="form-control field mb-3" placeholder="Your old password">
                            {/if}
                            <button type="button" class="show-hide-password" on:click={showHideOldPassword}><IconifyIcon icon={showOldPassword ? showIcon : hideIcon}/></button>
                        </div>
                        <!--<a href="#" class="forget-password">Forget password?</a>-->
                        <div class="position-relative">
                            {#if showNewPassword === true}
                                <input type="text" class="form-control field mb-3" bind:value={newPassword} placeholder="New password" autocomplete="none">
                            {:else}
                                <input type="password" class="form-control field mb-3" bind:value={newPassword} placeholder="New password" autocomplete="none">
                            {/if}
                            <button type="button" class="show-hide-password" on:click={showHideNewPassword}><IconifyIcon icon={showNewPassword ? showIcon : hideIcon}/></button>
                        </div>
                        <div class="position-relative">
                            {#if showRepeatPassword === true}
                                <input type="text" bind:value={repeatPassword} class="form-control field mb-3" placeholder="Repeat new password" autocomplete="none">
                            {:else}
                                <input type="password" bind:value={repeatPassword} class="form-control field mb-3" placeholder="Repeat new password" autocomplete="none">
                            {/if}
                            <button type="button" class="show-hide-password" on:click={showHideRepeatPassword}><IconifyIcon icon={showRepeatPassword ? showIcon : hideIcon}/></button>
                        </div>
                        <div class="invalid-feedback {errorStatus ? 'd-block' : ''}">{errorText}</div>
                        <button class="btn btn-primary" class:loading={changePasswordSending} on:click={changePassword}
                            disabled={changePasswordSending}><span>Change password</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .form-group label {
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: 500;
    }

    .field-note {
        font-weight: 300;
        font-size: 16px;
        line-height: 1.5;
        margin-bottom: 30px;
        max-width: 360px;
    }

    .form-group .form-control {
        border: 1px solid #CAD5E0;
        font-size: 16px;
        color: white;
    }

    .form-group .form-control:focus {
        border-color: #FF5D1C;
        box-shadow: none;
    }

    .form-group .form-control[readonly]:focus {
        border-color: #CAD5E0;
    }

    .pr-8 {
        padding-right: 80px;
    }

    .show-hide-password {
        position: absolute;
        background: none;
        right: 1px;
        top: 1px;
        height: 48px;
        width: 48px;
        color: #939599;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0;
        z-index: 2;
    }

    .forget-password {
        color: #2F80ED;
        font-size: 14px;
        font-weight: 300;
        margin: -5px 0 20px;
        display: table;
        text-decoration: none;
    }

    @media(max-width: 1299px) {
        .pr-8 {
            padding-right: 50px;
        }
    }

    @media(max-width: 991px) {
        .cabinet-wrapper .vertical-line:after {
            display: none;
        }

        .pr-8 {
            padding-right: 12px;
        }

        .field-note {
            font-size: 14px;
            line-height: 1.4;
            margin-bottom: 24px;
        }
    }

    @media(max-width: 767px) {
        .btn {
            width: 100%;
            font-size: 14px !important;
        }

        .form-control.field {
            padding: 10px;
            font-size: 16px;
        }

        .show-hide-password {
            height: 38px;
            width: 38px;
        }
    }
</style>
